import LeadXChangeConfiguration from '../../Views/Home/LeadXChangeView/LeadXChangeConfiguration/LeadXChangeConfiguration';
import LeadXChangeView from '../../Views/Home/LeadXChangeView/LeadXChangeView';

export const LeadXChangeRoutes = [
  {
    path: '/view',
    name: 'leadXchange_view',
    component: LeadXChangeView,
    layout: '/home/LeadXchange',
    default: true,
    isRoute: true,
    authorize: true,
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'leadXchange_view',
        isDisabled: true,
        route: '/home/LeadXchange/view',
        groupName: 'system-configuration',
      },
    ],
  },
  {
    path: '/LeadXChange-configuration',
    name: 'leadXchange_configuration',
    component: LeadXChangeConfiguration,
    layout: '/home/LeadXchange',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'LeadXchange Configuration',
        isDisabled: true,
        route: '/home/LeadXchange/LeadXChange-configuration',
        groupName: 'system-configuration',
      },
    ],
  },
];
